import { User, UserServerLike, UserToken } from '@serversgg/sdk-js'

import sdk from '../plugins/sdk'

async function setUserServerLikes (user, commit) {
  const userServerLikes = await UserServerLike
    .request()
    .setUriParam('user_id', user.data.id)
    .all()

  userServerLikes
    .all()
    .forEach(userServerLike => commit('likedServers/add', userServerLike, { root: true }))
}

export default {
  namespaced: true,

  state: {
    token: null,
    user: null,
  },

  actions: {
    async attempt ({ commit, state }, { email, password }) {
      const userToken = new UserToken()

      userToken.data.email = email
      userToken.data.password = password

      await userToken
        .request()
        .setInclude('user')
        .save()

      commit('setToken', userToken.data.token)
      commit('setUser', new User(userToken.data.user))

      await setUserServerLikes(state.user, commit)
    },

    async init ({ commit, dispatch, state }) {
      if (state.token) {
        sdk.updateConfig({
          authToken: state.token,
        })

        const response = await sdk.client().setUri('/user').send()

        if (response.getStatusCode() !== 200) {
          await dispatch('logout')
        } else {
          const data = await response.getJson()
          commit('setUser', new User(data))
        }
      }

      if (state.user) {
        await setUserServerLikes(state.user, commit)
      }
    },

    async logout ({ commit }) {
      // @TODO: Delete token.

      commit('setToken', null)
      commit('setUser', null)

      commit('likedServers/clear', null, { root: true })
    },
  },

  mutations: {
    setToken (state, newValue) {
      state.token = newValue

      sdk.updateConfig({
        authToken: newValue,
      })
    },

    setUser (state, newValue) {
      state.user = newValue
    },
  },
}
